import { ModelClient as h } from "@adobe/aem-spa-page-model-manager";
class a extends h {
  constructor(t, e, r) {
    super(t), this.user = e, this.password = r;
  }
  fetch(t) {
    if (!t)
      return Promise.reject(new Error(`Fetching model rejected for path: ${t}`));
    const e = this.apiHost || "", r = `${e}${t}`, c = e.indexOf("localhost") >= 0 && this.user && this.password ? {
      Authorization: this.getToken()
    } : {};
    return fetch(r, {
      headers: c
    }).then(async (s) => {
      if (!(s.status >= 200 && s.status < 300))
        throw {
          response: s
        };
      const n = await s.text();
      if (!n.length)
        throw "Received an empty response from AEM";
      return JSON.parse(n);
    }).catch((s) => Promise.reject(s));
  }
  getToken() {
    const t = `${this.user}:${this.password}`;
    return `Basic ${window.btoa(t)}`;
  }
}
const o = {};
class l extends a {
  fetch(t) {
    return o[t] ? Promise.resolve(o[t]) : super.fetch(t).then((e) => (o[t] = e, e));
  }
}
export {
  l as A,
  a as C
};
